import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminLayout.css';

function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  return (
    <>
      <div className="admin-bar">
        <a href="/admin" className="admin-bar-logo">
          ⚙ STRIXLY <span style={{color:'var(--text-mid)',fontWeight:400,marginLeft:4}}>ADMIN</span>
        </a>

        <nav className="admin-bar-nav">
          <NavLink to="/admin" end className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Dashboard</NavLink>
          <NavLink to="/admin/users" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Benutzer</NavLink>
          <NavLink to="/admin/recipes" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Rezepte</NavLink>
          <NavLink to="/admin/pages" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Seiten</NavLink>
          <NavLink to="/admin/modules" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Module</NavLink>
          <NavLink to="/admin/packages" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Pakete</NavLink>
          <NavLink to="/admin/regions" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Regionen</NavLink>
          <NavLink to="/admin/corrections" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Korrekturen</NavLink>
          <NavLink to="/admin/moderation" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')+' admin-bar-link-alert'}>Moderation</NavLink>
          <NavLink to="/admin/templates" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Templates</NavLink>
          <NavLink to="/admin/audit-log" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Audit-Log</NavLink>
          <NavLink to="/admin/settings" className={({isActive})=>'admin-bar-link'+(isActive?' active':'')}>Einstellungen</NavLink>
          <a href="/" className="admin-bar-link" target="_blank" rel="noopener">↗ Site</a>
        </nav>

        <div className="admin-bar-user">
          <span className="admin-bar-username">{user?.username}</span>
          <button className="admin-bar-logout" onClick={handleLogout}>Abmelden</button>
        </div>
      </div>

      <div className="admin-content">
        <Outlet />
      </div>
    </>
  );
}

export default AdminLayout;
